import React from "react";

function NewChevronDown({ fill = "#8C8594" }) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			fill="none"
			viewBox="0 0 20 20"
		>
			<path
				fill={fill}
				d="M9.37 6.963L5.261 11.61a1.104 1.104 0 000 1.428.82.82 0 001.261 0l3.482-3.929 3.471 3.928a.82.82 0 001.262 0 1.104 1.104 0 000-1.427l-4.107-4.647c-.34-.395-.913-.395-1.262 0z"
			/>
		</svg>
	);
}

export default NewChevronDown;
